/*
 * about (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { DevEnableImage } from "@psychology/dev"
import { AboutCard } from "@psychology/react-components"
import { Image, Page } from "@psychology/react-ui"
import {
	AppBuilt,
	Environment,
	AppSHA,
	AppTitle,
	AppVersion,
} from "@psychology/utils"
import { format } from "date-fns/format"
import { useTranslation } from "react-i18next"

export const Route = createFileRoute("/about")({ component: AboutPage })

function AboutPage() {
	const { t } = useTranslation()

	return (
		<Page>
			<AboutCard
				title={t("about.title")}
				subtitle={AppTitle}
				details={[
					Environment,
					`v${AppVersion}`,
					AppSHA !== "-" ? AppSHA : t("about.unknownSHA"),
					format(parseInt(AppBuilt, 10), "MMM d, h:mm a"),
				]}
			>
				<DevEnableImage>
					<Image
						src={"/assets/icons/transparent-192x192.png"}
						alt={"logo"}
						width={192}
						height={192}
					/>
				</DevEnableImage>
			</AboutCard>
		</Page>
	)
}
